import React from 'react';
import HeroSection from '../components/HeroSection';
import JoinAcm from '../components/JoinAcm';
import AboutAcmSection from '../components/AboutAcmSection';
import UpcomingEvents from '../components/UpcomingEvents';
import EventPosters from '../components/EventPosters';
import PastEvents from '../components/PastEvents';
import CtaSection from '../components/CtaSection';
import MarqueeText from '../components/MarqueeText';

const HomePage = () => {

  return (
    <div>
      <HeroSection />
      <MarqueeText />
      <div style={{ paddingTop: '10px' }}> 
        <UpcomingEvents />
        <EventPosters />
        <PastEvents />
        <JoinAcm />
        <AboutAcmSection />
        <CtaSection />
      </div>
    </div>
  );
};

export default HomePage;
